<template>

    <CCard>

        <CCardHeader>
            Настройки по башням
            <RestaurantTableOrderBadge />
        </CCardHeader>

        <CCardBody>
            
            <slot name="tabs"></slot>

            <CTabs
                variant="pills"
                :active-tab="0"
            >
                <CTab title="Наценка за доставку" class="pt-1">
                    <TowerSettingsDeliveryPrice
                        :entityType="entityType"
                        :entityId="entityId"
                        :addresses="formattedAddresses"
                        :deliveries="deliveryTypes"
                        :settings="deliveryPriceData"
                        @reload="fetch"
                    />
                </CTab>
                <CTab title="Время доставки" class="pt-1">
                    <TowerSettingsDeliveryTime
                        :entityType="entityType"
                        :entityId="entityId"
                        :addresses="formattedAddresses"
                        :settings="deliveryTimeData"
                        @reload="fetch"
                    />
                </CTab>
                <CTab title="Мин сумма заказа" class="pt-1">
                    <TowerSettingsMinPrice
                        :entityType="entityType"
                        :entityId="entityId"
                        :addresses="formattedAddresses"
                        :settings="minPriceData"
                        @reload="fetch"
                    />
                </CTab>
            </CTabs>

        </CCardBody>

        <!-- <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="save"
            >Сохранить все</CButton>
        </CCardFooter> -->
            
    </CCard>

</template>

<script>
    import { DELIVERY_TYPE } from '@/utils/order';
    import TowerSettingsDeliveryPrice from '@/components/tower-settings/TowerSettingsDeliveryPrice';
    import TowerSettingsDeliveryTime from '@/components/tower-settings/TowerSettingsDeliveryTime';
    import TowerSettingsMinPrice from '@/components/tower-settings/TowerSettingsMinPrice';

    export default {

        name: 'Delivery',

        components: {
            TowerSettingsDeliveryPrice,
            TowerSettingsDeliveryTime,
            TowerSettingsMinPrice
        },

        props: {
            entityType: {
                type: String,
                default: ''
            },
            entityId: {
                type: Number,
                default: null
            },
        },
  
        data () {
            return {
                settings: [],
                addresses: [],
                delivery: {
                    id: null,
                    entity_type: '',
                    entity_id: '',
                    priority: '',
                    address: [],
                    price: []
                },

                isPending: false,
            }
        },

        computed: {
            deliveryTypes() {
                return [
                    {
                        label: 'До двери',
                        value: DELIVERY_TYPE.DOOR
                    },
                    {
                        label: 'До точки встречи',
                        value: DELIVERY_TYPE.MEETING_POINT
                    },
                    {
                        label: 'Без доставки',
                        value: DELIVERY_TYPE.WITHOUT
                    },
                    {
                        label: 'Сборка заказа',
                        value: DELIVERY_TYPE.COLLECT
                    },
                ];
            },
            formattedAddresses() {
                return this.addresses.map(item => ({
                    label: item.name,
                    value: item.id,
                }));
            },
            deliveryPriceData() {
                return this.settings ? this.settings.filter(item => item.type === 'delivery_price') : [];
            },
            deliveryTimeData() {
                return this.settings ? this.settings.filter(item => item.type === 'delivery_time') : [];
            },
            minPriceData() {
                return this.settings ? this.settings.filter(item => item.type === 'min_price') : [];
            }
        },
    
        async mounted() {
            this.addresses = (await this.axios.get('/address')).data;
            await this.fetch();
        },
        
        methods: {
            async fetch() {
                this.settings = (await this.axios.get(`/entity-delivery-settings/${this.entityType}/${this.entityId}`)).data;
            },
        }
    }
</script>
